var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form flex col-4" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.tplRole.confName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.tplRole.realName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.bizUnitTypeMap[_vm.tplRole.bizUnitType] || ""))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.tplRole.mobAppRoleName))])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.checkActionPerm("bath_role_tpl") && _vm.comRoleIds.length > 0
      ? _c("div", { staticClass: "simple-row clearfix" }, [
          _c("div", { staticClass: "right" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.tplComRoleDlg()
                  }
                }
              },
              [_vm._v("批量更换职责权限")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mult-table" },
      [
        _vm._m(4),
        _vm._v(" "),
        _vm._l(_vm.viewDtoList, function(viewDto) {
          return _vm.viewDtoList.length > 0
            ? _c("div", { staticClass: "table-tr mult-table-bg" }, [
                _c(
                  "div",
                  {
                    staticClass: "table-td align-left",
                    staticStyle: {
                      "border-right": "1px solid #ddd",
                      "border-bottom": "1px solid #ddd"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(viewDto.bizUnitName) +
                          " - " +
                          _vm._s(viewDto.comName)
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "table-td" }, [
                  _c(
                    "div",
                    { staticClass: "mult-table second" },
                    _vm._l(viewDto.roleList, function(roleInfo) {
                      return _c("div", { staticClass: "table-tr" }, [
                        _c("div", { staticClass: "table-td pl5" }, [
                          _c("span", [_vm._v(_vm._s(roleInfo.name))])
                        ])
                      ])
                    })
                  )
                ])
              ])
            : _vm._e()
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.viewDtoList.length <= 0
      ? _c(
          "div",
          {
            staticClass: "font14 align-center font-gray2",
            staticStyle: { "margin-top": "100px" }
          },
          [_vm._v("暂无数据...")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("职责权限名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("目标岗位名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("移动端角色")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-tr th" }, [
      _c(
        "div",
        {
          staticClass: "table-td align-left",
          staticStyle: {
            "border-right": "1px solid #ddd",
            "border-bottom": "1px solid #ddd"
          }
        },
        [_c("span", [_vm._v("机构名称")])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-td" }, [
        _c("div", { staticClass: "mult-table third" }, [
          _c("div", { staticClass: "table-tr" }, [
            _c("div", { staticClass: "table-td pl5" }, [_vm._v("岗位名称")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04677e84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04677e84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/MerchtTplRoleDetail.vue
// module id = 3487
// module chunks = 0